export const CBookModel = {
  ID: '31f6043cc84947eea853ff0c8b80f0d6',
  /**
   * @deprecated Use `NAME` instead.
   */
  TYPE: 'book-page',
  NAME: 'book-page',
}
